import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a8f56ca6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_6m5rqjauvbyej62p7eiecas4wq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f56ca6",
  null
  
)

export default component.exports